import EventsPaginated from './page/[page]';
import type { RouteDefinition } from '@solidjs/router';

export default EventsPaginated;

export const route = { info: { nav: { hero: true } } } satisfies RouteDefinition;
